import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MedicalFeeWithholdTaxFilter } from '../../../model/medical-fee/medical-fee-with-holdTaxFilter';
import { FilterService } from '../../../services/filter.service';

@Component({
  selector: 'app-medical-fee-withhold-tax-dialog',
  templateUrl: './medical-fee-withhold-tax-dialog.component.html',
  styleUrls: ['./medical-fee-withhold-tax-dialog.component.css']
})
export class MedicalFeeWithholdTaxDialogComponent implements OnInit {

  form: FormGroup;
  loading: boolean;
  medicalFeeWithholdTaxs: MedicalFeeWithholdTaxFilter[] = [];
  aliquots: number[] = [];

  constructor(  public dialogRef: MatDialogRef<MedicalFeeWithholdTaxDialogComponent>,
                private notificationToastService: NotificationToastService,
                private filterService: FilterService,
                private formBuilder: FormBuilder,
                @Inject(MAT_DIALOG_DATA) public data: number[] ) {

    this.form = this.formBuilder.group({
      MedicalFeeWithholdTax: ['', Validators.required],
      Aliquot: ['', Validators.required]
    });
  }

  get f() { return this.form.controls; }

  async ngOnInit() {

    this.medicalFeeWithholdTaxs =
      await this.filterService.getMedicalFeeWithholdTaxFilters();

    if (  this.data && this.data.length > 0 ) {
      this.medicalFeeWithholdTaxs = this.medicalFeeWithholdTaxs.filter( m => {
        return this.data.findIndex( d => d === m.Id ) < 0;
      });
    }

    this.form.controls.MedicalFeeWithholdTax
      .valueChanges.subscribe(( info: MedicalFeeWithholdTaxFilter ) => {

        if ( info ) {
          this.aliquots = info.Aliquots;
        } else {
          this.aliquots = [];
        }

        this.form.patchValue({ Aliquot: '' });

    });
  }

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  save() {
    try {
      if (!this.form.invalid) {
          this.dialogRef.close(<MedicalFeeWithholdTaxDialogResponse>this.form.getRawValue());
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Retenciones');
    }
  }

}

export class MedicalFeeWithholdTaxDialogResponse {
  public MedicalFeeWithholdTax: MedicalFeeWithholdTaxFilter;
  public Aliquot: number;
}
